export default "__VITE_ASSET__DhtjzM9i__"